import { render, staticRenderFns } from "./ListLayoutKanban.vue?vue&type=template&id=5864442c&scoped=true"
import script from "./ListLayoutKanban.vue?vue&type=script&lang=ts"
export * from "./ListLayoutKanban.vue?vue&type=script&lang=ts"
import style0 from "./ListLayoutKanban.vue?vue&type=style&index=0&id=5864442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864442c",
  null
  
)

export default component.exports